import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ReferenceCardSkeleton({ index }: { index: number }) {
  return (
    <div
      className={cn(
        'animate-pulse',
        'flex w-full flex-col items-start justify-start gap-4 sm:gap-6 md:items-center md:justify-start md:gap-16 lg:gap-[72px]',
        {
          'md:flex-row': index % 2 === 0,
          'md:flex-row-reverse': index % 2 !== 0,
        },
      )}
    >
      <div className="relative h-[180px] w-full max-w-[680px] bg-neutral-100 sm:h-[250px] lg:h-[380px] xl:h-[430px]" />
      <div className='w-full max-w-[336px] flex flex-col items-start justify-start gap-4'>
        <div className='h-[28px] max-w-[200px] w-full bg-neutral-100' />
        <div className='w-full max-w-[280px] flex flex-col items-start justify-start gap-1'>
          <div className='w-[300px] h-[18px] sm:h-[22px] lg:h-[30px] xl:h-[36px] bg-neutral-100' />
          <div className='w-[195px] h-[18px] sm:h-[22px] lg:h-[30px] xl:h-[36px] bg-neutral-100' />
        </div>
        <div className='h-[28px] max-w-[100px] w-full bg-neutral-100' />
      </div>
    </div>
  );
}
